import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Inject } from '@angular/core';
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
    providedIn: 'root',
})
export class CallSummaryService {
    constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: AppConfig) {}

    getCallSummary(contactId: string, channel: string): Observable<any> {
        const headers = new HttpHeaders({
            'x-api-key': this.config.callSummaryApiKey,
            'Content-Type': 'application/json',
        });
        return this.http.post(
            this.config.callSummaryApi,
            {
                requestType: 'getCallSummaryForCSR',
                contactId,
                channel,
            },
            { headers }
        );
    }

    extractSummaryText(response: any): string | null {
        try {
            const data = typeof response?.body === 'string' ? JSON.parse(response.body) : response?.body || response;
            return data?.summary;
        } catch {
            return null;
        }
        return null;
    }
}
